// Change this
const module = 'pages'

import {checkAuth} from "@/services/auth";

// Change this
import Index from '@/views/cms/pages/Index'
import Create from '@/views/cms/pages/Create'
import Edit from '@/views/cms/pages/Edit'

var prefix = '/cms/'

export default [
    {
        path: prefix+`${module}/`,
        name: `${module}Index`,
        component: Index,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/create`,
        name: `${module}Create`,
        component: Create,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
    {
        path: prefix+`${module}/edit/:id`,
        name: `${module}Edit`,
        component: Edit,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
]
